import { Col, Row } from "reactstrap";
import BlogDetails from "./BlogDetails";
import Sidebar from "./Sidebar";
import PageImage from "../../CommonComponents/PageImage";

const RightSidebarContainer = () => {
  return (
    <section className="section-py-space blog-page ratio2_3">
      <PageImage/>
      <div className="custom-container">
        <div className="blog-sidebar">
          <Row className="g-4">
            <Col xl="9" lg="12">
              <div className="blog-card">
                <BlogDetails />
              </div>
            </Col>
            <Col xl="3" lg="12">
              <div className="blog-sidebar">
                <div className="blog-card">
                  <Sidebar />
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </section>
  );
};

export default RightSidebarContainer;
